import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{
    isAllAccessorialSelected: boolean;
}>;

export const DispatchSelectedAllAccessorials: HandlerType = props => {
    props.dispatch({
        type: "Custom/Accessorials/SelectedAllAccessorials",
        isAllAccessorialSelected: props.parameter.isAllAccessorialSelected,
    });
};

export const chain = [DispatchSelectedAllAccessorials];

const selectAllAccessorials = createHandlerChainRunner(chain, "selectAllAccessorials");
export default selectAllAccessorials;
